import ConfirmInvitationForm from '@plat/views/event/ConfirmInvitation.vue'

export default [
  {
    path: '/',
    component: ConfirmInvitationForm
  }
]
